<template>
	<div>
		<h6><strong>Datos de Nota</strong></h6>
		<div class="row">
			<div class="col-xl-2">
				<div class="form-group">
					<label for="" class="form-label">Nota de:</label>
					<InputSelect
						v-model="nota.tipoDoc"
						:options="containers.notaTiposDoc"
						label="nombre"
						:reduce="(opt) => opt.idDocVenta"
						name="Nota"
						vid="notaTipoDoc"
						rules="required"
						:disabled="esModoVista || loading.notaNumeroDoc"
						:loading="loading.notaNumeroDoc"
					></InputSelect>
				</div>
			</div>
			<div class="col-xl-2">
				<div class="row">
					<div class="col-xl-6">
						<div class="form-group">
							<label for="" class="form-label">Serie:</label>
							<div class="form-control form-control-sm disabled">{{ serieNota }}</div>
						</div>
					</div>
					<div class="col-xl-6">
						<div class="form-group">
							<label for="" class="form-label">Número:</label>
							<div class="form-control form-control-sm disabled">{{ nota.numeroDoc }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xl-4">
				<div class="form-group">
					<label for="" class="form-label">Tipo:</label>
					<InputSelect v-model="nota.tipoNota" :options="tiposNota" label="nombre" name="Tipo" vid="notaTipoNota" rules="required" :disabled="esModoVista"></InputSelect>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import InputSelect from "../../shared/components/InputSelect.vue";

export default {
	components: { InputSelect },
	computed: {
		...mapState("comprobante2", {
			nota: (state) => state.nota,
		}),
		...mapGetters("comprobante2", ["containers", "tiposNota", "serieNota", "esModoVista", "loading"]),
	},
};
</script>

<style></style>
